import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-1 flex-items-center flex-justify-between"
};
const _hoisted_2 = {
  class: "flex-center"
};
import { ref, reactive, watch } from 'vue';
import { useVModel } from '@vueuse/core';
import { getList } from '@/api/modules/role';
export default {
  __name: 'RolePicker',
  props: {
    modelValue: {
      type: [String, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const treeProps = {
      label: 'name',
      children: 'children',
      isLeaf: 'leaf',
      class: role => renderClass(role)
    };
    const $props = __props;
    const $emits = __emit;
    const value = useVModel($props, 'modelValue', $emits);
    const roleOptions = ref([]);
    const roleOrgOptions = ref([]);
    const orgTreeRef = ref();
    const expandedKeys = ref([]);
    const renderClass = role => {
      const val = roleOptions.value.find(e => e.id === role.id);
      if (val) {
        return 'is-active';
      } else {
        return '';
      }
    };
    const onNodeClick = data => {
      if ($props.multiple) {
        const index = roleOptions.value.findIndex(e => e.id === data.id);
        if (index === -1) {
          roleOptions.value.push(data);
          roleOptions.value.sort((a, b) => String(a.id).localeCompare(String(b.id)));
        } else {
          roleOptions.value.splice(index, 1);
        }
      } else {
        const index = roleOptions.value.findIndex(e => e.id === data.id);
        if (index === -1) {
          roleOptions.value = [data];
        } else {
          roleOptions.value.splice(index, 1);
        }
      }
    };
    const dialogVisible = ref(false);
    const queryForm = reactive({
      name: ''
    });
    watch(() => queryForm.name, val => {
      orgTreeRef.value && filter(val);
    });
    const filterNode = (value, data) => {
      if (!value) return true;
      return data.name.includes(value);
    };
    const open = () => {
      dialogVisible.value = true;
    };
    const onOpen = () => {
      getList().then(res => {
        if (res.success) {
          roleOrgOptions.value = res.data.map(e => {
            return {
              id: e.id,
              name: e.name
            };
          });
        }
      });
      let roleIds = [];
      if (Array.isArray(value.value)) {
        roleIds.push(...value.value);
      } else if (value.value) {
        roleIds.push(value.value);
      }
      if (roleIds.length > 0) {
        getList(roleIds).then(res => {
          if (res.success) {
            roleOptions.value = res.data.map(role => {
              return {
                id: role.id,
                name: role.name
              };
            });
            roleOptions.value.sort((a, b) => String(a.id).localeCompare(String(b.id)));
          }
        });
      } else {
        roleOptions.value = [];
      }
    };
    const handelConfirm = () => {
      if ($props.multiple) {
        value.value = roleOptions.value.map(e => e.id);
      } else {
        if (roleOptions.value.length > 0) {
          value.value = roleOptions.value[0].id;
        } else {
          value.value = null;
        }
      }
      dialogVisible.value = false;
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_School = _resolveComponent("School");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_Check = _resolveComponent("Check");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        onOpen: onOpen,
        "align-center": "",
        draggable: "",
        title: "选择角色",
        width: "30%"
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[1] || (_cache[1] = $event => dialogVisible.value = false)
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: handelConfirm
        }, "确认")]),
        default: _withCtx(() => [_createVNode(_component_el_card, {
          shadow: "never",
          class: "org-card"
        }, {
          header: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: queryForm.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryForm.name = $event),
            placeholder: "输入关键字进行查询",
            style: {
              width: '100%'
            },
            "suffix-icon": "search",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
            tag: "div",
            class: "org-tree"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tree, {
              ref_key: "orgTreeRef",
              ref: orgTreeRef,
              "node-key": "id",
              data: roleOrgOptions.value,
              "default-expanded-keys": expandedKeys.value,
              props: treeProps,
              "filter-node-method": filterNode,
              onNodeClick: onNodeClick
            }, {
              default: _withCtx(({
                data
              }) => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, {
                size: 16
              }, {
                default: _withCtx(() => [_createVNode(_component_School)]),
                _: 1
              }), _createTextVNode("  " + _toDisplayString(data.name), 1)]), _createVNode(_component_el_icon, {
                class: "is-selected"
              }, {
                default: _withCtx(() => [_createVNode(_component_Check)]),
                _: 1
              })])]),
              _: 1
            }, 8, ["data", "default-expanded-keys"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};